import React, { useState } from 'react';
export function BrandLogo({
  name,
  icon
}: {
  name: string;
  icon: string;
}) {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return <span className="font-display text-lg font-black tracking-tight" data-id="element-634" data-mp="3qs7xfn31mlof">{name}</span>;
  }
  return <img src={`https://cdn.simpleicons.org/${icon}/ffffff`} alt={name} loading="lazy" onError={() => setFailed(true)} className="h-8 w-auto max-w-[96px] object-contain sm:h-9" data-id="element-635" data-mp="8hwc1zrk78lz" />;
}